import * as actionTypes from './actionTypes'
import { handleActions } from 'redux-actions'
import { omit } from 'lodash/fp'

const reducers = {}

reducers[actionTypes.WS_ATTEMPT_CONNECT] = {
  next (state, action) {
    return {
      ...state,
      [action.meta.platform]: {
        ...state[action.meta.platform],
        connected: false,
        pinging: false
      }
    }
  }
}

reducers[actionTypes.WS_RECONNECT_FAILED] = {
  next (state, action) {
    return {
      ...state,
      [action.meta.platform]: {
        ...state[action.meta.platform],
        connected: false,
        pinging: false
      }
    }
  }
}

reducers[actionTypes.WS_CONNECT_FINISHED] = {
  next (state, action) {
    return {
      ...state,
      [action.meta.platform]: {
        ...state[action.meta.platform],
        connected: true,
        method: action.payload.kandy.method,
        platform: action.meta.platform,
        ...omit('checkConnectivity', action.payload.kandy)
      }
    }
  },
  throw (state, action) {
    return {
      [action.meta.platform]: {
        connected: false,
        pinging: false
      }
    }
  }
}

reducers[actionTypes.LOST_CONNECTION] = {
  next (state, action) {
    return {
      ...state,
      [action.meta.platform]: {
        ...state[action.meta.platform],
        connected: false,
        pinging: false
      }
    }
  }
}

reducers[actionTypes.WS_DISCONNECT_FINISHED] = {
  next (state, action) {
    return {
      [action.meta.platform]: {
        connected: false,
        pinging: false
      }
    }
  },
  throw (state, action) {
    return {
      [action.meta.platform]: {
        connected: false,
        pinging: false
      }
    }
  }
}

reducers[actionTypes.WS_ERROR] = {
  next (state, action) {
    return {
      [action.meta.platform]: {
        connected: false,
        pinging: false
      }
    }
  },
  throw (state, action) {
    return {
      [action.meta.platform]: {
        connected: false,
        pinging: false
      }
    }
  }
}

/*
  Accepts a boolean payload for checkConnectivity
 */
reducers[actionTypes.CHANGE_CONNECTIVITY_CHECKING] = {
  next (state, action) {
    return {
      ...state,
      checkConnectivity: action.payload
    }
  }
}

/*
  Accepts a payload for pingInterval in MILLISECONDS
 */
reducers[actionTypes.CHANGE_PING_INTERVAL] = {
  next (state, action) {
    return {
      ...state,
      pingInterval: action.payload
    }
  }
}

/**
 * Connectivity Interface reducer
 * @method reducer
 * @param  {Object}  state - The current redux state.
 * @param  {Object}  action - A flux standard action.
 * @return {Object}  - The new redux state.
 */
const reducer = handleActions(reducers, {})
export default reducer
